import { OptionCategory, LazyOption } from 'owa-options-core';
import { GeneralOptions } from 'owa-options-general';
import { MailOptions } from 'owa-options-mail';
import { CalendarOptions } from 'owa-options-calendar';
import { PremiumOptions } from 'owa-options-premium';
import 'owa-options-mail'; // Imported to bootstrap several services
import { computed, IComputedValue } from 'mobx';
import { isOptionAllowed } from 'owa-allowed-options';

export const UNFILTERED_OPTIONS: OptionCategory[] = [
    GeneralOptions,
    MailOptions,
    CalendarOptions,
    PremiumOptions,
];

let collectedOptions = computed(() => {
    return UNFILTERED_OPTIONS.map(category => {
        category = {
            ...category,
            subcategories: category.subcategories
                .map(subcategory => {
                    subcategory = {
                        ...subcategory,
                        options: subcategory.options.filter(isOptionHidden),
                    };
                    return subcategory;
                })
                .filter(subcategory => subcategory.options.length > 0),
        };
        return category;
    }).filter(category => category.subcategories.length > 0);
}) as IComputedValue<OptionCategory[]>;

export function isOptionHidden(option: LazyOption) {
    return (
        !(option.isHidden && option.isHidden()) && isOptionAllowed(option.allowedOptionKeys || [])
    );
}

export default () => collectedOptions.get();

export { OptionCategory };
